import { render, staticRenderFns } from "./McLang.vue?vue&type=template&id=13f00e7e&scoped=true"
import script from "./McLang.vue?vue&type=script&lang=js"
export * from "./McLang.vue?vue&type=script&lang=js"
import style0 from "./McLang.vue?vue&type=style&index=0&id=13f00e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f00e7e",
  null
  
)

export default component.exports